/**
 * 渠道对接信息
 */

import { getLocalItem } from '@/utils/localStorage'

export const useChannel = () => {
  /**
   * 是否渠道合作
   */
  const hasChannelCode = () => {
    const channelCode = getLocalItem('zl-mctcode')
    return channelCode
  }

  /**
   * 大唐渠道
   */
  const datangChannel = () => {
    return hasChannelCode() === '0050'
  }

  return {
    hasChannelCode,
    datangChannel
  }
}
